import AnimationTypeEnum from './AnimationConstants';

const DEFAULT_STATIC_BUILDER_PROGRESS_STEP = 40;
const DEFAULT_STATIC_BUILDER_TOTAL_STEPS = 100;

export const startProgressBarAnimation = (steps, interval) => (
  (dispatch) => {
    dispatch({
      type: AnimationTypeEnum.ANIMATION_START,
      animationType: AnimationTypeEnum.PROGRESS_BAR_ANIMATION,
      totalSteps: steps,
      stepInterval: interval,
    });

    for (let i = 0; i < steps; i += 1) {
      setTimeout(() => {
        dispatch({
          type: AnimationTypeEnum.ANIMATION_STEP_SET,
          animationType: AnimationTypeEnum.PROGRESS_BAR_ANIMATION,
          step: i,
        });
      }, i * interval);
    }

    setTimeout(() => {
      dispatch({
        type: AnimationTypeEnum.ANIMATION_FINISH,
        animationType: AnimationTypeEnum.PROGRESS_BAR_ANIMATION,
      });
    }, steps * interval);
  }
);


export const startSelfServeBuilderFieldPlacementDoneAnimation = (fieldId, fieldType) => (
  (dispatch) => {
    // initialize params needed for animation of field from editor to section organizer
    dispatch({
      type: AnimationTypeEnum.ANIMATION_UPDATE,
      animationType: AnimationTypeEnum.SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION,
      updatedAnimationState: {
        fieldIdToAnimate: fieldId,
        fieldType,
      },
    });

    dispatch({
      type: AnimationTypeEnum.ANIMATION_START,
      animationType: AnimationTypeEnum.SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION,
    });

    setTimeout(() => {
      dispatch({
        type: AnimationTypeEnum.ANIMATION_STEP_SET,
        animationType: AnimationTypeEnum.SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION,
        step: 1,
      });
    }, 50);

    setTimeout(() => {
      dispatch({
        type: AnimationTypeEnum.ANIMATION_FINISH,
        animationType: AnimationTypeEnum.SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION,
      });

      dispatch({
        type: AnimationTypeEnum.ANIMATION_UPDATE,
        animationType: AnimationTypeEnum.SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION,
        updatedAnimationState: {
          started: false,
          finished: false,
          step: 0,
        },
      });
    }, 750);
  }
);

export const setStaticBuilderSaveProgressBarAnimationStep = step => (
  (dispatch) => {
    dispatch({
      type: AnimationTypeEnum.ANIMATION_STEP_SET,
      animationType: AnimationTypeEnum.STATIC_BUILDER_SAVE_ANIMATION,
      step,
    });
  }
);

export const startStaticBuilderSaveProgressBarAnimation = () => (
  (dispatch) => {
    dispatch({
      type: AnimationTypeEnum.ANIMATION_START,
      animationType: AnimationTypeEnum.STATIC_BUILDER_SAVE_ANIMATION,
      totalSteps: DEFAULT_STATIC_BUILDER_TOTAL_STEPS,
    });
  }
);

export const finishStaticBuilderSaveProgressBarAnimation = () => (
  (dispatch) => {
    dispatch({
      type: AnimationTypeEnum.ANIMATION_UPDATE,
      animationType: AnimationTypeEnum.STATIC_BUILDER_SAVE_ANIMATION,
      updatedAnimationState: {
        started: false,
        finished: false,
        step: DEFAULT_STATIC_BUILDER_PROGRESS_STEP,
        totalSteps: DEFAULT_STATIC_BUILDER_TOTAL_STEPS,
      },
    });
  }
);

export const disableStaticBuilderSaveProgressBarAnimation = () => (
  (dispatch) => {
    dispatch({
      type: AnimationTypeEnum.ANIMATION_UPDATE,
      animationType: AnimationTypeEnum.STATIC_BUILDER_SAVE_ANIMATION,
      updatedAnimationState: {
        disabled: true,
      },
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/Animation/AnimationActions.jsx